module.exports = __webpack_public_path__ + "img/whimsey-necklace-4.cd7f376e.jpg";